<template>
  <el-row>
    <el-col data-v-step="createGroupForm">
      <el-form  :model="form" ref="form" :rules="rules" @click="$event.stopPropagation()" >
        <el-form-item :label="$t('tree.groupName')" label-width="120px" prop="name">
          <el-input v-model="form.name" @keyup.enter.native="save"></el-input>
        </el-form-item>
        <el-form-item :label="$t('tree.tagCode')" label-width="120px" prop="tagCode">
          <el-input v-model="form.tagCode" @keyup.enter.native="save"  @input="sanitize($event)">
            <span slot="prefix">#</span>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="save()">{{$t('tree.create')}}</el-button>
          <el-button @click="cancel()">{{$t('tree.cancel')}}</el-button>
        </el-form-item>
      </el-form>
    </el-col>
  </el-row>
</template>

<script>
import axios from "axios";
import { url } from "../service/url";
export default {
  name: "create-group",
  event: ["created", "cancelled"],
  props: ["parentGroupId"],
  data() {
    return {
      form: {
        name: "",
        tagCode: ""
      },
      rules: {
        name: [
          {
            required: true,
            message: this.$t("tree.pleaseInputName"),
            trigger: "blur"
          }
        ],
        tagCode: [
          {
            required: true,
            message: this.$t("tree.pleaseInputTagCode"),
            trigger: "change"
          }
        ]
      }
    };
  },

  methods: {
    sanitize(tagCode) {
      this.form.tagCode = tagCode
        .trim()
        .toUpperCase()
        .replace(/[^a-zA-Z 0-9]/g, "");
    },
    cancel() {
      //this.$refs["form"].resetFields();
      this.$emit("cancelled", null);
    },
    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          axios
            .post(`${process.env.VUE_APP_APIURL}/tree/group/${this.parentGroupId}/group`, this.form)
            .then(res => {
              this.$emit("created", {
                _id: res.data._id,
                tagCode: `#${this.form.tagCode}`,
                name: this.form.name
              });
              this.$refs["form"].resetFields();
            })
            .catch(e => {
              this.$message.error(e.response.data.message);
            });
        }
      });
    }
  }
};
</script>

<style scoped>
.el-input--prefix .el-input__inner {
  padding-left: 15px;
}
.el-input {
  width: 200px;
}
</style>